import { render, staticRenderFns } from "./Salary Reports.vue?vue&type=template&id=f7561370"
import script from "./Salary Reports.vue?vue&type=script&lang=js"
export * from "./Salary Reports.vue?vue&type=script&lang=js"
import style0 from "./Salary Reports.vue?vue&type=style&index=0&id=f7561370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports